// @ts-nocheck
import EmbedTab from './EmbedTab';
import { Dialog, DialogTitle, DialogContent, Box } from '@mui/material';
import { XGButton } from 'xg-cl';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const EmbedModal = ({ open, onClose, tripId }) => {
  const { t } = useTranslation(['embed', 'common']);

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>{t('trip:embedCode', 'Embed Code')}</DialogTitle>
      <DialogContent
        sx={{ padding: '25px 24px !important', paddingTop: '0 !important' }}
      >
        <EmbedTab tripid={tripId} />

        <Box className='share-dialog-close-button'>
          <XGButton
            data-testid='share-dialog-close-button'
            id='dialog-close-button'
            text={t('common:close')}
            type='secondary'
            size='large'
            variant='outlined'
            onClick={onClose}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

EmbedModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  tripId: PropTypes.number.isRequired
};

export default EmbedModal;
